"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatus = void 0;
/**
 * Represents transaction status of the application for a financial product
 * provided by VWFS.
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["INITIALIZED"] = "INITIALIZED";
    TransactionStatus["CALCULATED"] = "CALCULATED";
    TransactionStatus["CALCULATION_INVALID"] = "CALCULATION_INVALID";
    TransactionStatus["OFFER_GENERATED"] = "OFFER_GENERATED";
    TransactionStatus["OFFER_ACCEPTED"] = "OFFER_ACCEPTED";
    TransactionStatus["LEGITIMATION_INITIALIZED"] = "LEGITIMATION_INITIALIZED";
    TransactionStatus["LEGITIMATION_REFUSED"] = "LEGITIMATION_REFUSED";
    TransactionStatus["LEGITIMATION_CONDUCTED"] = "LEGITIMATION_CONDUCTED";
    TransactionStatus["LEGITIMATION_FRONTEND_CONDUCTED"] = "LEGITIMATION_FRONTEND_CONDUCTED";
    TransactionStatus["LEGITIMATION_DIGITAL_CONDUCTED"] = "LEGITIMATION_DIGITAL_CONDUCTED";
    TransactionStatus["LEGITIMATION_INVALID"] = "LEGITIMATION_INVALID";
    TransactionStatus["APPLICATION_STARTED"] = "APPLICATION_STARTED";
    TransactionStatus["MANUAL_APPLICATION_STARTED"] = "MANUAL_APPLICATION_STARTED";
    TransactionStatus["DAC_APPLICATION_STARTED"] = "DAC_APPLICATION_STARTED";
    TransactionStatus["APPLICATIONFORM_STARTED"] = "APPLICATIONFORM_STARTED";
    TransactionStatus["APPLICATIONFORM_COMPLETED"] = "APPLICATIONFORM_COMPLETED";
    TransactionStatus["DOCUMENTS_UPLOADED"] = "DOCUMENTS_UPLOADED";
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["ACCEPTED"] = "ACCEPTED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["ABORTED"] = "ABORTED";
    TransactionStatus["FINALLY_PAYED"] = "FINALLY_PAYED";
    TransactionStatus["COMPLETED"] = "COMPLETED";
    TransactionStatus["LEAD_SUBMITTED"] = "LEAD_SUBMITTED";
    TransactionStatus["CREDITCHECK_STARTED"] = "CREDITCHECK_STARTED";
    TransactionStatus["CREDIT_REQUESTED"] = "CREDIT_REQUESTED";
    TransactionStatus["CREDIT_PENDING"] = "CREDIT_PENDING";
    TransactionStatus["CREDIT_PENDING_CUSTOM_EMAIL"] = "CREDIT_PENDING_CUSTOM_EMAIL";
    TransactionStatus["CREDIT_CHECKED"] = "CREDIT_CHECKED";
    TransactionStatus["CREDIT_REFUSED"] = "CREDIT_REFUSED";
    TransactionStatus["CREDIT_APPROVED"] = "CREDIT_APPROVED";
    TransactionStatus["CREDIT_APPROVED_OBLIGATIONS"] = "CREDIT_APPROVED_OBLIGATIONS";
    TransactionStatus["CREDIT_TO_BE_CONFIRMED"] = "CREDIT_TO_BE_CONFIRMED";
    TransactionStatus["CREDIT_INVALID"] = "CREDIT_INVALID";
    TransactionStatus["CREDIT_CUSTOMER_ACTION_REQUIRED"] = "CREDIT_CUSTOMER_ACTION_REQUIRED";
    TransactionStatus["CREDIT_OFFER_MODIFIED"] = "CREDIT_OFFER_MODIFIED";
    TransactionStatus["CREDIT_REFUSED_GUARANTOR_REQUIRED"] = "CREDIT_REFUSED_GUARANTOR_REQUIRED";
    TransactionStatus["SOFTCREDIT_APPROVED"] = "SOFTCREDIT_APPROVED";
    TransactionStatus["SOFTCREDIT_REFUSED"] = "SOFTCREDIT_REFUSED";
    TransactionStatus["CONTRACT_PRINTED"] = "CONTRACT_PRINTED";
    TransactionStatus["ESIGN_READY"] = "ESIGN_READY";
    TransactionStatus["ESIGN_STARTED"] = "ESIGN_STARTED";
    TransactionStatus["ESIGN_COMPLETED"] = "ESIGN_COMPLETED";
    TransactionStatus["ESIGN_REFUSED"] = "ESIGN_REFUSED";
    TransactionStatus["ESIGN_ABORTED"] = "ESIGN_ABORTED";
    TransactionStatus["ESIGN_FAILED"] = "ESIGN_FAILED";
    TransactionStatus["CONTRACT_SIGNED"] = "CONTRACT_SIGNED";
    TransactionStatus["CONTRACT_CONFIRMED"] = "CONTRACT_CONFIRMED";
    TransactionStatus["CONFIRMATION_PRINTED"] = "CONFIRMATION_PRINTED";
    TransactionStatus["CANCELED"] = "CANCELED";
    TransactionStatus["BOP_COMPLETED"] = "BOP_COMPLETED";
    TransactionStatus["APPLICATION_APPROVED"] = "APPLICATION_APPROVED";
    TransactionStatus["APPLICATION_COMPLETED"] = "APPLICATION_COMPLETED";
    TransactionStatus["APPLICATION_UNDER_REVIEW"] = "APPLICATION_UNDER_REVIEW";
    TransactionStatus["CONTRACT_INTERRUPTED"] = "CONTRACT_INTERRUPTED";
    TransactionStatus["LEGITIMATION_SUCCESSFUL_DATA_INCONSISTENT"] = "LEGITIMATION_SUCCESSFUL_DATA_INCONSISTENT";
    TransactionStatus["LEGITIMATION_SUCCESSFUL_DATA_MATCHED"] = "LEGITIMATION_SUCCESSFUL_DATA_MATCHED";
    TransactionStatus["TRANSACTION_EXPIRED"] = "TRANSACTION_EXPIRED";
    TransactionStatus["VEHICLE_INVALID"] = "VEHICLE_INVALID";
    TransactionStatus["VEHICLE_UNAVAILABLE"] = "VEHICLE_UNAVAILABLE";
    TransactionStatus["RESERVATION_FEE_OPENED"] = "RESERVATION_FEE_OPENED";
    TransactionStatus["RESERVATION_FEE_COMPLETED"] = "RESERVATION_FEE_COMPLETED";
    TransactionStatus["DEPOSIT_PAYMENT_OPENED"] = "DEPOSIT_PAYMENT_OPENED";
    TransactionStatus["DEPOSIT_PAYMENT_PENDING"] = "DEPOSIT_PAYMENT_PENDING";
    TransactionStatus["DEPOSIT_PAYMENT_DECLINED"] = "DEPOSIT_PAYMENT_DECLINED";
    TransactionStatus["DEPOSIT_PAYMENT_COMPLETED"] = "DEPOSIT_PAYMENT_COMPLETED";
    TransactionStatus["TIMER_EXPIRED"] = "TIMER_EXPIRED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
